import { MemoryBlockstore } from '@alanshaw/pail/block';
import { DbLoader, IdxLoader } from './loader';
export class Transaction extends MemoryBlockstore {
    parent;
    constructor(parent) {
        super();
        this.parent = parent;
        this.parent = parent;
    }
    async get(cid) {
        return this.parent.get(cid);
    }
    async superGet(cid) {
        return super.get(cid);
    }
}
class FireproofBlockstore {
    ready;
    name = null;
    loader = null;
    opts = {};
    transactions = new Set();
    constructor(name, LoaderClass, opts) {
        this.opts = opts || this.opts;
        if (name) {
            this.name = name;
            this.loader = new LoaderClass(name, this.opts);
            this.ready = this.loader.ready;
        }
        else {
            this.ready = Promise.resolve(LoaderClass.defaultHeader);
        }
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    async put() {
        throw new Error('use a transaction to put');
    }
    async get(cid) {
        for (const f of this.transactions) {
            const v = await f.superGet(cid);
            if (v)
                return v;
        }
        if (!this.loader)
            return;
        return await this.loader.getBlock(cid);
    }
    async commitCompaction(t, head) {
        this.transactions.clear();
        this.transactions.add(t);
        return await this.loader?.commit(t, { head }, true);
    }
    async *entries() {
        const seen = new Set();
        for (const t of this.transactions) {
            for await (const blk of t.entries()) {
                if (seen.has(blk.cid.toString()))
                    continue;
                seen.add(blk.cid.toString());
                yield blk;
            }
        }
    }
    async executeTransaction(fn, commitHandler) {
        const t = new Transaction(this);
        this.transactions.add(t);
        const done = await fn(t);
        const { car, done: result } = await commitHandler(t, done);
        return car ? { ...result, car } : result;
    }
}
export class IndexBlockstore extends FireproofBlockstore {
    constructor(name, opts) {
        super(name || null, IdxLoader, opts);
    }
    async transaction(fn, indexes) {
        return this.executeTransaction(fn, async (t, done) => {
            indexes.set(done.name, done);
            const car = await this.loader?.commit(t, { indexes });
            return { car, done };
        });
    }
}
export class TransactionBlockstore extends FireproofBlockstore {
    constructor(name, opts) {
        // todo this will be a map of headers by branch name
        super(name || null, DbLoader, opts);
    }
    async transaction(fn) {
        return this.executeTransaction(fn, async (t, done) => {
            const car = await this.loader?.commit(t, done);
            return { car, done };
        });
    }
}
